<template>
  <modal 
    :show.sync="show"
    modal-classes="modal-lg"
    @close="close">
    <div 
      slot="base-content" 
      class="card card-plain mb-0">
      <div class="modal-header justify-content-center">
        <button 
          type="button" 
          class="btn-sm close text-dark" 
          data-dismiss="modal" 
          aria-hidden="true"
          @click="close">
          <i class="now-ui-icons ui-1_simple-remove"/>
        </button>
        <div class="header header-primary text-center">
          <h4 class="font-weight-bold m-0">Reservation Receipt</h4>
        </div>
      </div>
      <div class="modal-body pt-0">
        <div 
          v-if="data"
          class="card-body p-0">
          <div class="row">
            <div class="col-12 text-right">
              <n-button
                type="success"
                @click.native="print">
                Print
              </n-button>
            </div>
            <div class="col-12">
              <div class="text-center">
                <img 
                  v-lazy="`${apiUrl}reservation/barcode?reservationId=${data.id}&size=8`">
              </div>
              <h4 class="text-center mt-2">{{ data.name }}</h4>
            </div>
            <div class="col-md-6">
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Booking Date: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-normal m-0">{{ bookingDate }}</h5>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Check In: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-normal m-0">{{ checkIn }}</h5>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Check Out: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-normal m-0">{{ checkOut }}</h5>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Length: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-normal m-0">{{ length }}</h5>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Daily Rate: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-normal m-0">{{ data.cost.maxDailyRate | currency }}</h5>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Total Daily: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-normal m-0">{{ data.cost.totalBaseRate | currency }}</h5>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Processing Fee: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-normal m-0">{{ data.cost.appliedProcessingFee.amount | currency }}</h5>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-12">
                  <el-collapse accordion>
                    <el-collapse-item name="1">
                      <template slot="title">
                        <div class="col-5">
                          <i class="bx bx-plus mr-1" />
                          <i class="bx bx-minus mr-1" />
                          
                          Fees: 
                        </div>
                        <div class="col-7 pl-0">
                          <h5 class="font-weight-normal m-0">{{ data.cost.totalFees | currency }}</h5>
                        </div>
                      </template>
                      <ul>
                        <li 
                          v-for="fee in data.cost.fees"
                          :key="fee.id">
                          <div class="row align-items-center">
                            <div class="col-5">
                              {{ fee.description }}:
                            </div>
                            <div class="col-7 pl-0">
                              <h5 class="font-weight-normal m-0">{{ fee.amount | currency }}</h5>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Total: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-bold m-0">{{ data.cost.totalRate | currency }}</h5>
                </div>
              </div>
            </div>
            <div class="col-md-6 text-right">
              <n-button
                type="info"
                link
                class="m-0 px-0"
                @click.native="directions">
                Directions
                <i class="bx bxs-chevron-right" />
              </n-button>
              <gmap-map
                ref="gMap"
                :center="{
                  lat: data.coordinate.coordinates[1],
                  lng: data.coordinate.coordinates[0]
                }"
                :options="{scrollwheel: false}"
                :zoom="15"
                class="map">
                <gmap-marker 
                  :position="{
                    lat: data.coordinate.coordinates[1],
                    lng: data.coordinate.coordinates[0]
                }"/> 
              </gmap-map>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-end">
        <n-button
          type="danger"
          @click.native="close">
          Close
        </n-button>
      </div>
    </div>
  </modal>
</template>
<script>
  import axios from 'axios';
  import moment from 'moment';
  // import jsPDF from 'jspdf';
  import { mapState, mapMutations } from 'vuex';
  import { Collapse as ElCollapse, CollapseItem as ElCollapseItem, Notification } from 'element-ui';
  import { Button, FormGroupInput, Modal } from '@/components';

  export default {
    components: {
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput,
      Modal,
      [ElCollapse.name]: ElCollapse,
      [ElCollapseItem.name]: ElCollapseItem,
    },
    props: {
      open: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        show: false,
        loading: false,
        apiUrl: process.env.VUE_APP_API_URL
      };
    },
    computed: {
      ...mapState([
        'options'
      ]),
      bookingDate() {
        return moment(this.data.modified).format('MM/DD/YYYY HH:mm A');
      },
      checkIn() {
        return moment(this.data.startDate + ' ' + this.data.startTime).format('MM/DD/YYYY HH:mm A');
      },
      checkOut() {
        return moment(this.data.endDate + ' ' + this.data.endTime).format('MM/DD/YYYY HH:mm A');
      },
      length() {
        const diff = moment(new Date(this.data.endDate + ' ' + this.data.endTime)).diff(moment(new Date(this.data.startDate + ' ' + this.data.startTime)), 'minutes');
        const days = Math.floor(diff / 60 / 24);
        const hours = Math.floor((diff - days * 60 * 24) / 60);
        const mins = diff - days * 24 * 60 - hours * 60;
        
        let length = days + 'Days ';
        if (hours > 0) {
          length += hours + 'Hrs '
        }
        if (mins > 0) {
          length += mins + 'Mins';
        }

        return length.trim();
      }
    },
    watch: {
      open() {
        this.show = this.open;
      }
    },
    created() {
    },
    methods: {
      close() {
        this.$emit('close');
      },
      directions() {
        const aTag = document.createElement('a');
        aTag.href = `http://maps.google.com/maps?q=${this.data.coordinate.coordinates[1]},${this.data.coordinate.coordinates[0]}`
        aTag.target = '_blank';
        aTag.click();
      },
      print() {
        window.print();

        // const doc = new jsPDF("p", "mm", "a4");
        // const width = doc.internal.pageSize.getWidth();
        // const height = doc.internal.pageSize.getHeight();

        // const logo = new Image();
        // logo.src = `img/logo-prefix.png`;
        // doc.addImage(logo, 'png', 16, 8, 10, 10);
        // doc.setFontSize(14);
        // doc.text(` ${this.options.logoText}`, 26, 15);
        // doc.line(16, 18, width - 16, 18);

        // const img = new Image();
        // img.src = `https://api.airportparking.club/reservation/qr?value=${this.data.barcode}`;
        // doc.addImage(img, 'png', 75, 20, 60, 60);

        // doc.setFontSize(24);
        // doc.text(this.data.name, width / 2, 90, {align: 'center', maxWidth: width - 32});

        // doc.setFontSize(16);
        // doc.text('Name: ', 55, 110);
        // doc.text(`${this.data.memberName}`, 100, 110);
        // doc.text('Email: ', 55, 118);
        // doc.text(`${this.data.memberEmail}`, 100, 118);

        // doc.text('Booking Date: ', 55, 130);
        // doc.text(`${this.bookingDate}`, 100, 130);
        // doc.text('Check In: ', 55, 138);
        // doc.text(`${this.checkIn}`, 100, 138);
        // doc.text('Check Out: ', 55, 146);
        // doc.text(`${this.checkOut}`, 100, 146);
        // doc.text('Length: ', 55, 154);
        // doc.text(`${this.length}`, 100, 154);
        // doc.text('Daily Rate: ', 55, 162);
        // doc.text(`$${this.data.cost.maxDailyRate}`, 100, 162);
        // doc.text('Total Daily: ', 55, 170);
        // doc.text(`$${this.data.cost.totalBaseRate}`, 100, 170);
        // doc.text('Processing Fee: ', 55, 178);
        // doc.text(`$${this.data.cost.appliedProcessingFee.amount}`, 100, 178);
        // doc.text('Location Fees: ', 55, 186);
        // doc.text(`$${this.data.cost.totalFees}`, 100, 186);
        
        // doc.setFontSize(12);
        // this.data.cost.fees.forEach((fee, i) => {
        //   const top = 192 + i * 6;
        //   if (top > height - 24) {
        //     doc.addPage();
        //   }
        //   doc.text(`${fee.description}: `, 60, top, {maxWidth: 44});
        //   doc.text(`$${fee.amount}`, 105, top);          
        // });

        // doc.setFontSize(18);
        // const top = 186 + this.data.cost.fees.length * 6 + 10;
        // if (top > height - 24) {
        //   doc.addPage();
        // }
        // doc.text('Total: ', 55, top);
        // doc.text(`$${this.data.cost.totalRate}`, 100, top);

        // doc.setFontSize(12);
        // doc.text('1', width / 2, height - 10, {align: 'center'});

        // doc.save(this.data.id + '.pdf');
      }
    }
  }
</script>
<style lang='scss' scoped>
  ::v-deep .el-collapse {
    border: 0 !important;

    .el-collapse-item__header {
      height: auto !important;
      line-height: unset !important;
      font-size: inherit !important;
      margin-bottom: 4px;
      border: 0 !important;
      margin-left: -15px;
      margin-right: -15px;

      .bx-plus {
        display: inline-block;
      }
      .bx-minus {
        display: none;
      }

      &.is-active {
        .bx-plus {
          display: none;
        }
        .bx-minus {
          display: inline-block;
        }
      }
    }

    .el-collapse-item__wrap {
      border: 0 !important;

      .el-collapse-item__content {
        padding-bottom: 4px;
      }
    }

    .el-collapse-item__arrow {
      display: none;
    }
  }
  .map {
    height: calc(100% - 34px);

    @media (max-width: 576px) {
      height: 50vh;
    }
  }
</style>
